import React from 'react';
import Statistics from '../statistics/Statistics';

const Dashboard = () => {
  return (
    <div>
      <Statistics />
    </div>
  );
};

export default Dashboard; 